(() => {
  class ProductPromoSavings {
    constructor(root) {
      this.root = root;
      this.scope = root.closest('product-info') || document;
      this.basePriceMinor = this.toMinor(root.dataset.basePriceMinor);
      this.addOnTotalMinor = 0;
      this.discountPercent = Number(root.dataset.discountPercent) || 0;
      this.quantityInput = this.scope.querySelector('input[name="quantity"]');
      this.onOptionPriceChange = this.onOptionPriceChange.bind(this);
      this.onQuantityChange = this.onQuantityChange.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    init() {
      if (this.root.dataset.productPromoSavingsBound === 'true') return;
      this.root.dataset.productPromoSavingsBound = 'true';
      this.scope.addEventListener('optionsight:price-change', this.onOptionPriceChange);
      this.quantityInput?.addEventListener('input', this.onQuantityChange);
      this.quantityInput?.addEventListener('change', this.onQuantityChange);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
      }

      this.update();
    }

    toMinor(value) {
      const amount = Number.parseInt(value, 10);
      return Number.isFinite(amount) ? Math.max(0, amount) : 0;
    }

    getQuantity() {
      const quantity = Number.parseInt(this.quantityInput?.value || '1', 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    formatMoney(amountMinor) {
      const currency = window.Shopify?.currency?.active || 'USD';
      const locale = window.Shopify?.locale || document.documentElement.lang || 'en-US';
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(amountMinor / 100);
      } catch {
        return `$${(amountMinor / 100).toFixed(2)}`;
      }
    }

    onOptionPriceChange(event) {
      this.addOnTotalMinor = this.toMinor(event.detail?.addOnTotalMinor);
      this.update();
    }

    onQuantityChange() {
      this.update();
    }

    onVariantChange(event) {
      const variant = event?.data?.variant;
      if (!variant) return;
      this.basePriceMinor = this.toMinor(variant.price);
      this.root.hidden = !variant.available;
      this.update();
    }

    update() {
      const configurationTotalMinor = (this.basePriceMinor + this.addOnTotalMinor) * this.getQuantity();
      const savingsMinor = Math.round(configurationTotalMinor * (this.discountPercent / 100));
      this.scope.querySelectorAll('[data-product-promo-savings-amount]').forEach((amount) => {
        amount.textContent = this.formatMoney(savingsMinor);
      });
      this.root.dataset.currentSavingsMinor = String(savingsMinor);
    }
  }

  const initializeProductPromoSavings = (scope = document) => {
    scope.querySelectorAll('[data-product-promo-savings-root]').forEach((root) => {
      new ProductPromoSavings(root).init();
    });
  };

  document.addEventListener('product-info:loaded', (event) => initializeProductPromoSavings(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeProductPromoSavings());
  } else {
    initializeProductPromoSavings();
  }
})();
